// extracted by mini-css-extract-plugin
export default {"fullPage":"PageLoader_fullPage__YdxUg","inline":"PageLoader_inline__pKr82","loadingText":"PageLoader_loadingText__VE-Zj"};